import { useEffect } from 'react';

import './ConfirmModal.scss';

const ConfirmModal = ({
  isOpen,
  title = 'Confirm',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  onConfirm,
  onCancel,
  children,
  // Both default off, so every existing caller behaves exactly as before.
  confirmDisabled = false,
  isLoading = false,
}) => {
  // Escape closes it: this is the only way out for a keyboard user, and some
  // of these dialogs confirm something destructive.
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => { if (e.key === 'Escape' && !isLoading) onCancel?.(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, isLoading, onCancel]);

  if (!isOpen) return null;

  return (
    <div className="confirm-overlay" onClick={isLoading ? undefined : onCancel}>
      <div className="confirm-dialog" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <h2 className="confirm-title">{title}</h2>
        <p className="confirm-message">{message}</p>
        {children}
        <div className="confirm-actions">
          <button className="confirm-cancel" onClick={onCancel} disabled={isLoading}>{cancelLabel}</button>
          <button
            className={`confirm-submit ${danger ? 'confirm-submit--danger' : ''}`}
            onClick={onConfirm}
            disabled={confirmDisabled || isLoading}
            style={confirmDisabled || isLoading ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}
          >
            {isLoading ? 'Working…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
